module.exports = __webpack_public_path__ + "assets/images/project/cover/cover-tablet.png?v=df4817c3";